"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_CAFE24_UPDATE_THEMES_SCRIPTTAG = exports.API_CAFE24_LIST_THEMES_SCRIPTTAG = exports.API_CAFE24_SHOP_LIST = void 0;
var API_CAFE24_SHOP_LIST;
(function (API_CAFE24_SHOP_LIST) {
    API_CAFE24_SHOP_LIST.PATH = '/cafe24/shop-list';
    API_CAFE24_SHOP_LIST.PURPOSE = '카페24 멀티쇼핑몰 목록조회';
})(API_CAFE24_SHOP_LIST = exports.API_CAFE24_SHOP_LIST || (exports.API_CAFE24_SHOP_LIST = {}));
var API_CAFE24_LIST_THEMES_SCRIPTTAG;
(function (API_CAFE24_LIST_THEMES_SCRIPTTAG) {
    API_CAFE24_LIST_THEMES_SCRIPTTAG.PATH = '/cafe24/list-themes-scripttag';
    API_CAFE24_LIST_THEMES_SCRIPTTAG.PURPOSE = 'CAFE24 디자인별 스크립트 설치상태 조회';
})(API_CAFE24_LIST_THEMES_SCRIPTTAG = exports.API_CAFE24_LIST_THEMES_SCRIPTTAG || (exports.API_CAFE24_LIST_THEMES_SCRIPTTAG = {}));
var API_CAFE24_UPDATE_THEMES_SCRIPTTAG;
(function (API_CAFE24_UPDATE_THEMES_SCRIPTTAG) {
    API_CAFE24_UPDATE_THEMES_SCRIPTTAG.PATH = '/cafe24/update-themes-scripttag';
    API_CAFE24_UPDATE_THEMES_SCRIPTTAG.PURPOSE = 'CAFE24 디자인별 스크립트 설치상태 변경';
})(API_CAFE24_UPDATE_THEMES_SCRIPTTAG = exports.API_CAFE24_UPDATE_THEMES_SCRIPTTAG || (exports.API_CAFE24_UPDATE_THEMES_SCRIPTTAG = {}));
//# sourceMappingURL=api-cafe24.js.map